import "./PaymentTypeInput.scss";
import { PAYMENT_METHODS, PAYMENT_TERMS } from "app/constants";
import { FormattedMessage } from "react-intl";
import SwissBillingPaymentType from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentMethodsFieldsetNew/SwissBilling/SwissBillingPaymentType";
import IdealPaymentType from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentMethodsFieldsetNew/Ideal/IdealPaymentType";
import PropTypes from "prop-types";
import CreditCardPaymentType from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentMethodsFieldsetNew/creditCard/CreditCardPaymentType";
import CreditCardFieldsetContainer from "app/pages/Booking/Payment/CreditCardFieldset/CreditCardFieldsetContainer";
import { useFormikContext } from "formik";
import RadioFormik from "app/pages/.shared/form/RadioFormik";
import {
	PaiementPaypalBlackIcon,
	PaiementApplepayIcon,
	PaiementGooglepayIcon,
} from "app/icons/logo";

const PaymentTypeInput = ({
	paymentType = {},
	ideal = {},
	mensualite2Fois = {},
	total,
	isAdyenFlow,
	onCreditCardInputsBlur,
	onAdyenComponentMounted = () => {},
	onChange,
	onCreditCardSubmit,
	onAdyenAdditionalDetails,
	disabled,
	swissbilling = { forbiddenCause: "", cgvURL: "" },
}) => {
	const { values } = useFormikContext();

	let bodyComponent = false;
	let headerComponent = false;
	let conditionnalDisabled = disabled;
	let conditionnalForbiddenComponent = false;

	if (
		paymentType.paymentType === PAYMENT_METHODS.CARD ||
		paymentType.paymentType === PAYMENT_METHODS.ADYEN_FLOW
	) {
		headerComponent = (
			<div className="payment-type__line">
				<FormattedMessage id="payment.method.adyen_api_card" />
			</div>
		);

		if (disabled) {
			bodyComponent = false;
		} else if (paymentType.terms === PAYMENT_TERMS["1x"]) {
			bodyComponent = (
				<CreditCardPaymentType
					payNowAmount={total}
					isAdyenFlow={isAdyenFlow}
					onCreditCardInputsBlur={onCreditCardInputsBlur}
					onAdyenComponentMounted={onAdyenComponentMounted}
					onCreditCardSubmit={onCreditCardSubmit}
					onAdyenAdditionalDetails={onAdyenAdditionalDetails}
				/>
			);
		} else if (paymentType.terms === PAYMENT_TERMS["2x"]) {
			bodyComponent = (
				<CreditCardPaymentType
					payNowAmount={mensualite2Fois.payNowAmount}
					isAdyenFlow={isAdyenFlow}
					payLaterAmount={mensualite2Fois.payLaterAmount}
					dueDate={mensualite2Fois.dueDate}
					onCreditCardInputsBlur={onCreditCardInputsBlur}
					onAdyenComponentMounted={onAdyenComponentMounted}
					onCreditCardSubmit={onCreditCardSubmit}
					onAdyenAdditionalDetails={onAdyenAdditionalDetails}
				/>
			);
		}
	} else if (paymentType.paymentType === PAYMENT_METHODS.BCMC) {
		headerComponent = (
			<div className="payment-type__line">
				<FormattedMessage id="payment.method.bcmc" />
				<div className="payment-type__icons">
					<i className={`icon icon--bancontact payment-type__icon`} />
				</div>
			</div>
		);

		bodyComponent = !disabled && (
			<CreditCardFieldsetContainer
				values={values?.payment?.cardBCMC}
				onBlur={onCreditCardInputsBlur}
				isAdyenFlow={isAdyenFlow}
				onAdyenComponentMounted={onAdyenComponentMounted}
				onSubmit={onCreditCardSubmit}
				onAdyenAdditionalDetails={onAdyenAdditionalDetails}
			/>
		);
	} else if (paymentType.paymentType === PAYMENT_METHODS.SWISS_BILLING) {
		conditionnalForbiddenComponent = swissbilling.forbiddenCause;
		conditionnalDisabled = disabled || swissbilling.forbiddenCause;
		headerComponent = (
			<div>
				<div className="payment-type__line">
					<FormattedMessage
						id="payment.method.swissbilling"
						values={{
							note: (
								<span className="payment-type__note">
									<FormattedMessage id="payment.method.swissbilling.2" />
								</span>
							),
						}}
					/>
					<div className="payment-type__icons">
						<i className={`icon icon--swissbilling payment-type__icon`} />
					</div>
				</div>
				<div className="payment-type__line--note">
					<FormattedMessage id="payment.method.swissbilling.note" />
				</div>
			</div>
		);

		bodyComponent = !conditionnalDisabled && (
			<SwissBillingPaymentType
				swissBillingCGVURL={swissbilling.cgvURL}
				total={total}
				maxAmount={swissbilling.maxAmount}
			/>
		);
	} else if (paymentType.paymentType === PAYMENT_METHODS.IDEAL) {
		headerComponent = (
			<div className="payment-type__line">
				<FormattedMessage id="payment.method.ideal" />
				<div className="payment-type__icons">
					<i className={`icon icon--ideal payment-type__icon`} />
				</div>
			</div>
		);
		bodyComponent = !disabled && (
			<IdealPaymentType
				total={total}
				idealIssuers={paymentType.issuers}
				onIssuerSelect={ideal.onPaymentBankChange}
			/>
		);
	} else if (paymentType.paymentType === PAYMENT_METHODS.SOFORT) {
		headerComponent = (
			<div className="payment-type__line">
				<FormattedMessage id="payment.method.sofort" />
				<div className="payment-type__icons">
					<i className={`icon icon--sofort payment-type__icon`} />
				</div>
			</div>
		);
	} else if (paymentType.paymentType === PAYMENT_METHODS.GIROPAY) {
		headerComponent = (
			<div className="payment-type__line">
				<FormattedMessage id="payment.method.giropay" />
				<div className="payment-type__icons">
					<i className={`icon icon--giropay payment-type__icon`} />
				</div>
			</div>
		);
	} else if (paymentType.paymentType === PAYMENT_METHODS.POSTFINANCE_CARD) {
		headerComponent = (
			<div className="payment-type__line">
				<FormattedMessage id="payment.method.postfinance_card" />
				<div className="payment-type__icons">
					<i className={`icon icon--postfinance-card payment-type__icon`} />
				</div>
			</div>
		);
	} else if (paymentType.paymentType === PAYMENT_METHODS.POSTFINANCE_EFINANCE) {
		headerComponent = (
			<div className="payment-type__line">
				<FormattedMessage id="payment.method.postfinance_efinance" />
				<div className="payment-type__icons">
					<i className={`icon icon--postfinance-efinance payment-type__icon`} />
				</div>
			</div>
		);
	} else if (paymentType.paymentType === PAYMENT_METHODS.PAYPAL) {
		headerComponent = (
			<div className="payment-type__line">
				<FormattedMessage id="payment.method.paypal" />
				<div className="payment-type__icons">
					<PaiementPaypalBlackIcon
						height={20}
						width={20}
						className="icon payment-type__icon"
					/>
				</div>
			</div>
		);
	} else if (paymentType.paymentType === PAYMENT_METHODS.CHECKOUT) {
		// we suppose here that if the paymentType.paymentType is "checkout", then user pays with Apple Pay and Google Pay
		headerComponent = (
			<div className="payment-type__line">
				<FormattedMessage id="payment.method.checkout" />
				<div className="payment-type__icons">
					<PaiementApplepayIcon
						height={20}
						width={20}
						className="icon payment-type__icon"
					/>
					<PaiementGooglepayIcon
						height={20}
						width={20}
						className="icon payment-type__icon"
					/>
				</div>
			</div>
		);
	}

	const isPaymentMethodSelected = values?.payment?.type === paymentType.paymentType;
	return (
		<div className="payment-type">
			{conditionnalForbiddenComponent && (
				<div className="payment-methods-fieldset-new__message--forbidden">
					{conditionnalForbiddenComponent}
				</div>
			)}
			{conditionnalDisabled ? (
				<RadioFormik
					showIcon={true}
					name="payment.type"
					id={paymentType.paymentType}
					value={paymentType.paymentType}
					disabled={conditionnalDisabled}
					data-testid={`payment-type-input-${paymentType.paymentType}`}
				>
					<div className="payment-type__content">{headerComponent}</div>
				</RadioFormik>
			) : (
				<RadioFormik
					showIcon={true}
					name="payment.type"
					id={paymentType.paymentType}
					value={paymentType.paymentType}
					body={
						isPaymentMethodSelected &&
						bodyComponent && <div className="payment-type__body">{bodyComponent}</div>
					}
					toggle={() => {
						onChange(paymentType.paymentType);
					}}
					data-testid={`payment-type-input-${paymentType.paymentType}`}
				>
					<div className="payment-type__content">{headerComponent}</div>
				</RadioFormik>
			)}
		</div>
	);
};

PaymentTypeInput.propTypes = {
	paymentType: PropTypes.object,
	onAdyenComponentMounted: PropTypes.func,
	onCreditCardInputsBlur: PropTypes.func,
	onAdyenAdditionalDetails: PropTypes.func,
	onCreditCardSubmit: PropTypes.func,
	onChange: PropTypes.func,
	total: PropTypes.number,
	mensualite2Fois: PropTypes.object,
	swissbilling: PropTypes.object,
	isAdyenFlow: PropTypes.bool,
	disabled: PropTypes.bool,
	ideal: PropTypes.object,
};

export default PaymentTypeInput;
